/* eslint-disable */

;
(function () {
  'use strict';

  let _global;
  var WX = window.wx;
  let CWXShare = {
    share(config, show) {
      share(config, show);
    }
  };
  function share(config, show) {
    if (!isWX()) {
      return false;
    }
    if (localStorage.getItem('signature')) {
      let signature = localStorage.getItem('signature');
      wxShare(JSON.parse(signature), config, show);
    }
  }
  function wxShare(data, shareConfig, show) {
    var timestamp = data.timestamp;
    var nonceStr = data.nonceStr;
    var singvalue = data.signature;
    var appId = data.appId;
    console.log('data', data);
    WX.config({
      debug: false,
      appId: 'wxd12d31cf907e12ba' || appId,
      // 和获取Ticket的必须一样------必填，公众号的唯一标识
      timestamp: timestamp,
      // 必填，生成签名的时间戳
      nonceStr: nonceStr,
      // 必填，生成签名的随机串
      signature: singvalue,
      // 必填，签名，见附录1
      // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem']
    });

    // 处理验证成功的信息
    WX.ready(function () {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      WX.updateAppMessageShareData({
        title: shareConfig.title,
        // 分享标题
        desc: shareConfig.desc,
        // 分享描述
        link: shareConfig.link,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareConfig.imgUrl,
        // 分享图标
        success: function (res) {
          console.log('自定义“分享给朋友”及“分享到QQ”按钮: ', res);
        }
      });
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      WX.updateTimelineShareData({
        title: shareConfig.title,
        // 分享标题
        link: shareConfig.link,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareConfig.imgUrl,
        // 分享图标
        success: function (res) {
          console.log('自定义“分享到朋友圈”及“分享到QQ空间”按钮: ', res);
        }
      });
      if (!show) {
        WX.hideAllNonBaseMenuItem();
      } else {
        WX.showAllNonBaseMenuItem();
      }
    });
  }
  function isWX() {
    var ua = window.navigator.userAgent.toLowerCase();
    // eslint-disable-next-line
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }
  _global = function () {
    return this || (0, eval)('this');
  }();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = CWXShare;
  } else if (typeof define === 'function' && define.amd) {
    define(function () {
      return CWXShare;
    });
  } else {
    !('CWXShare' in _global) && (_global.CWXShare = CWXShare);
  }
})();